import { useNetworkRequest } from '@mp/hooks/useNetworkRequest';
import { UseMutateFunction, useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import omit from 'lodash/omit';
import { EditValuesProps } from './interface';

export const useWorkExperienceMutations = (): {
  submitWorkExperienceInfo: UseMutateFunction<AxiosResponse<any>, unknown, any, unknown>;
  editWorkExperienceInfo: UseMutateFunction<AxiosResponse<any>, unknown, any, unknown>;
} => {
  const { axios } = useNetworkRequest();
  const queryClient = useQueryClient();

  const { mutate: submitWorkExperienceInfo } = useMutation(
    (values) => axios.post(`/v3/professional/work_histories`, values),
    {
      onSettled: () => {
        queryClient.invalidateQueries(['currentUser']);
        queryClient.invalidateQueries(['GetWorkHistoriesForExperienceSummaryView']);
        queryClient.invalidateQueries(['GetWorkHistoryForWorkExperience']);
        queryClient.invalidateQueries(['GetCurrentUserForWorkExperience']);
      },
    },
  );

  const { mutate: editWorkExperienceInfo } = useMutation(
    (values: EditValuesProps) =>
      axios.put(`/v3/professional/work_histories/${values.id}`, {
        work_history: omit(values, 'id'),
      }),
    {
      onSettled: () => {
        queryClient.invalidateQueries(['currentUser']);
        queryClient.invalidateQueries(['GetWorkHistoriesForExperienceSummaryView']);
        queryClient.invalidateQueries(['GetWorkHistoryForWorkExperience']);
        queryClient.invalidateQueries(['GetCurrentUserForWorkExperience']);
      },
    },
  );

  return {
    submitWorkExperienceInfo,
    editWorkExperienceInfo,
  };
};
